import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { impactedAssetGroupOrder } from "../../types/impactReport";

import {
    AssetListWrapper,
    AssetRowWrapper,
    SkeletonBar,
    SkeletonRowHeader,
    SkeletonTab,
    SkeletonTabList,
} from "./styles";

const SKELETON_ROW_WIDTHS = ["220px", "180px", "260px", "200px", "240px"];

/**
 * Mirrors the loaded layout — tab strip on top, list below — so nothing shifts down when data lands.
 * Tab counts are skeleton bars, not real numbers: they are not known until the response arrives.
 */
export const ImpactReportSkeleton = () => (
    <Stack
        flex="1"
        minHeight="0"
        aria-hidden
        data-automation="industry-transition-impact-report-skeleton"
    >
        <SkeletonTabList>
            {impactedAssetGroupOrder.map((group) => (
                <SkeletonTab
                    key={group}
                    data-automation={`industry-transition-impact-report-skeleton-tab-${group}`}
                >
                    <Stack gap="6px">
                        <SkeletonBar $width="90px" />
                        <SkeletonBar $width="32px" />
                    </Stack>
                </SkeletonTab>
            ))}
        </SkeletonTabList>

        <AssetListWrapper gap="8px">
            {SKELETON_ROW_WIDTHS.map((width) => (
                <AssetRowWrapper key={width}>
                    <SkeletonRowHeader>
                        <Flex
                            gap="8px"
                            alignItems="center"
                        >
                            <SkeletonBar $width="16px" />
                            <SkeletonBar $width={width} />
                        </Flex>
                        <SkeletonBar $width="120px" />
                    </SkeletonRowHeader>
                </AssetRowWrapper>
            ))}
        </AssetListWrapper>
    </Stack>
);
